import {computed, makeObservable} from 'mobx';
import {BaseModel} from "../../base-model";
import {ANIMATION, BaseAnimation} from "../base-animation";
import {AnimationDomainModel} from "../../../../domain/common/animation/animation.domain-model";

export class BaseAnimationSetModel extends BaseModel {
  animation: AnimationDomainModel;

  constructor(animation) {
    super(animation);

    makeObservable(this);

    this.animation = animation;
  }

  get id(): Number {
    return this.animation.id;
  }

  get uniqueId(): Number {
    return this.animation.uniqueId;
  }

  @computed get animations(): Array<BaseAnimation> {
    return [];
  }

  @computed get isEnded(): Boolean {
    let isEnded = true;
    this.animations.forEach((animation: BaseAnimation) => isEnded &= (!animation || (animation.state === ANIMATION.LIFE_CYCLE.ended)));

    return !!isEnded;
  }

  start() {
    this.animations.forEach((animation: BaseAnimation) => animation && animation.start());
  }

  leave() {
    this.animations.forEach((animation: BaseAnimation) => animation && animation.leave());
  }

  stop() {
    this.animations.forEach((animation: BaseAnimation) => animation && animation.stop());
  }
}
